module.exports = __webpack_public_path__ + "static/img/16.d8d117b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/16.jpg
// module id = i+7p
// module chunks = 16